import { pathExists } from 'fs-extra';
import { Logger } from '../utils/logger';
import { FileWriter } from '../utils/file-writer';
import { versionJsonReplaces } from '../configs/replace-config';

/**
 * The upgrader for the version.ts
 */
export class VersionJsonUpgrader {
    private readonly fileName = 'version.json';
    private filePath: string;
    private fileWriter: FileWriter;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     */
    constructor(filePath: string) {
        this.filePath = filePath;
        this.messages.notFound = `${this.fileName} not found at ${this.filePath}.`
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                // guarantee the version is 4.x
                if(!this.fileWriter.getData().includes('"version": "4')) {
                    this.fileWriter
                    .tabToTwoSpaces()
                    .replaceVersion(versionJsonReplaces)
                    .writeFile();
                }
            } else {
                Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
